import DetailTitle from "@/components/DetailTitle"
import styles from './index.module.scss'
const RelatedResource = ({ relatedResources }) => {
	const arr = relatedResources.split(',')
	return (
		<div>
			<DetailTitle title="Related Resource" />
			{arr.map((item, index) =>
				<div key={index + '_resource'} className={styles.resourceBox}>{(index + 1) + '、' + item}</div>
			)}
		</div>
	)
}
export default RelatedResource;